import { IS_WOA, LOGIN_14_DAYS_KEY } from '@/pages/home/_config/config';
export const FILTER_CACHE_VALUE_KEY = '__dbd_filter_cache__';
/** *
 * 对象树种查找某个值
 * @param (object,key, [key])
 */
export function find() {
  let arr = Array.prototype.slice.call(arguments);
  return arr.reduce((obj, key) => {
    return typeof obj === 'object' ? obj[key] : undefined;
  });
}

/** *
 * 清除字符串两端空格
 * @param
 */
export function trim(str: string) {
  return str ? str.replace(/(^\s*)|(\s*$)/g, '') : str;
}

/** *
 * 设置cookie
 * @param
 */
export function setCookie(
  name: string,
  value: string,
  expiredays?: number,
  path?: string,
  domain?: string,
) {
  let exdate = new Date();
  if (expiredays) {
    exdate.setDate(exdate.getDate() + expiredays);
  }

  document.cookie =
    name +
    '=' +
    escape(value) +
    (!path ? '' : ';path=' + path) +
    (!domain ? '' : ';domain=' + domain) +
    (!expiredays ? '' : ';expires=' + exdate.toGMTString());
}

/** *
 * 获取cookie
 * @param
 */
export function getCookie(key: string) {
  let temp: any;
  const arr = document.cookie.split(';').map((item) => {
    temp = item.split('=');
    return { key: trim(temp[0]), value: trim(temp[1]) };
  });
  arr
    .filter((item) => item.key === key)
    .some((item) => {
      if (item.value) {
        temp = item;
        return true;
      }
      return false;
    });
  return unescape(temp?.value || '');
}

/** *
 * 清除cookie
 * @param whiteCookie 白名单cookie，白名单中的cookie，不清除
 */
export function clearCookie(whiteCookie: string[] = []) {
  let cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf('=');
    let name = eqPos > -1 ? trim(cookie.substr(0, eqPos)) : cookie;
    if (whiteCookie.indexOf(name) > -1) {
      continue;
    }
    document.cookie = `${name}=;domain=${
      location.hostname
    };expires=${new Date().toUTCString()};path=/`;
    document.cookie = `${name}=;expires=${new Date().toUTCString()};path=/`;
  }
}

/** *
 * 设置stroage
 * @param
 */
export const storage = {
  getType(type: string) {
    return type === 'localStorage' ? 'localStorage' : 'sessionStorage';
  },
  getItem(key: string, type = 'localStorage') {
    const objstr = window[this.getType(type)].getItem(key);
    if (!objstr) return null;
    try {
      const json = JSON.parse(objstr) || {};
      const { _value, _expire } = json;
      if (_expire) {
        if (Date.now() > _expire) {
          // 过期，删掉记录
          this.removeItem(key, type);
          return null;
        }
        return _value;
      }
      if (Object.prototype.hasOwnProperty.call(json, '_value')) {
        return _value;
      }
      return json;
    } catch (e) {
      return objstr;
    }
  },

  setItem(key: string, val: any, type = 'localStorage', expire?: number) {
    // 可以存空字符串、0、false
    if (val === undefined || val === null) {
      // 清除记录
      this.removeItem(key, type);
      return;
    }
    const obj = {
      _value: val,
    } as any;
    if (expire) {
      obj._expire = expire;
    }
    window[this.getType(type)].setItem(key, JSON.stringify(obj));
  },

  removeItem(key: string, type = 'localStorage') {
    window[this.getType(type)].removeItem(key);
  },

  getLocalStorageItem(key: string) {
    return this.getItem(key, 'localStorage');
  },

  setLocalStorageItem(key: string, val: any, expire?: number) {
    this.setItem(key, val, 'localStorage', expire);
  },

  removeLocalStorageItem(key: string) {
    this.removeItem(key, 'localStorage');
  },

  getSessionStorageItem(key: string) {
    return this.getItem(key, 'sessionStorage');
  },

  setSessionStorageItem(key: string, val: any, expire?: number) {
    this.setItem(key, val, 'sessionStorage', expire);
  },

  removeSessionStorageItem(key: string) {
    this.removeItem(key, 'sessionStorage');
  },
};

/** *
 * 获取页面base 路径
 * @param
 */
export const getBasePath = (): string => {
  const pathname = window.location.pathname;
  if (pathname.startsWith('/v2')) {
    return '/v2';
  }
  if (pathname.startsWith('/rebuildv2')) {
    return '/rebuildv2';
  }
  return '';
};

/** *
 * 设置登录
 * @param
 */
export function setLogin(authorization: string) {
  window.sessionStorage.setItem('authorization', authorization);
  setCookie('db-authorization', authorization, '', '/');
}

/** *
 * 获取登录token
 * @param
 */

export function getAuthorization() {
  return (
    getCookie('db-authorization') ||
    window.sessionStorage.getItem('authorization')
  );
}

export const doLogout = () => {
  window.sessionStorage.removeItem('authorization');
  window.sessionStorage.removeItem(FILTER_CACHE_VALUE_KEY);
  window.localStorage.removeItem('lockCacheValue');
  window.localStorage.removeItem(LOGIN_14_DAYS_KEY);
  clearCookie();
  const redirect = encodeURIComponent(window.location.href);
  if (IS_WOA) {
    window.location.replace(`/_logout/?url=${redirect}`);
  } else {
    window.location.replace(`${getBasePath()}/login?redirect=${redirect}`);
  }
};

// 返回一个字符串的字节长度，一个中文占两个字节
export const getStrlen = (str: string) => {
  let len = 0;
  const re = /[\u4e00-\u9fa5]/;
  for (let i = 0, l = str.length; i < l; i += 1) {
    if (re.test(str.charAt(i))) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
};

/**
 * 获取固定宽度的字符串，如果传入的text的宽度不够width,则返回原字符串
 * @text   将要被提取的原字符串
 * @width  想要提取的字符串长度
 * @fontSize  字符串显示时的字符大小，支持>=12
 * @isNeedEllipsis   当text的宽度大于width时是否需要省略号，会在传入的width基础上加，最后返回字符串宽度会>width
 */
export const getFixedWidthText = (
  text: string,
  width: number,
  fontSize = 12,
  fontWeight = 400,
  isNeedEllipsis = true,
) => {
  let returnText = '';
  let oldText = '';
  let newText = '';
  if (!text || width < fontSize || typeof text !== 'string') return returnText;
  const arr = text.split('');
  const span: HTMLSpanElement = document.createElement('span');
  span.style.visibility = 'hidden';
  span.style.padding = '0';
  // @ts-ignore
  span.style['white-space'] = 'nowrap';
  // @ts-ignore
  span.style['overflow-x'] = 'auto';
  span.style.fontSize = fontSize > 12 ? fontSize + 'px' : '12px';
  // @ts-ignore
  span.style.fontWeight = fontWeight;
  document.body.appendChild(span);

  for (let i = 0, l = arr.length; i < l; i += 1) {
    const item = arr[i];
    oldText = newText;
    newText += item;
    returnText = newText;
    span.innerHTML = newText;
    const nowWidth = span.offsetWidth;
    if (nowWidth > width) {
      if (isNeedEllipsis) {
        returnText = oldText + '...';
      } else {
        returnText = oldText;
      }
      break;
    }
  }

  document.body.removeChild(span);
  return returnText;
};
